import DefaultPopup from 'components/Utils/DefaultPopup';
import PromoCodeFields from 'components/Utils/PromoCodeFields';
import React from 'react';

const PromoCodeModal = (props) => (
  <DefaultPopup
    title={`Add ${props.referral ? 'Referral' : 'Promo'} Code`}
    className="promo-code-popup"
    openHandler={[props.promoCodeModal, (value) => props.openPromoCodeModal(value)]}
  >
    <PromoCodeFields
      patient={props.patient}
      onSuccess={(newPlans) => {
        props.openPromoCodeModal(false);
        if (props.onReceivedNewPlans) props.onReceivedNewPlans(newPlans);
      }}
      referral={props.referral}
    />
  </DefaultPopup>
);

export default PromoCodeModal;
